import React, { useState } from 'react';
import axios from 'axios';

const ServicesImageUploader = () => {
  const [fileInput, setFileInput] = useState(null);
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState(null);

  const handleFileChange = (e) => {
    setFileInput(e.target.files[0]);
  };

  const handleImageUpload = async (image) => {
    const formData = new FormData();
    formData.append('file', image);
    formData.append('upload_preset', 'ml_default');

    try {
      const res = await axios.post(
        'https://api.cloudinary.com/v1_1/dca5poo9m/image/upload',
        formData
      );
      return res.data.secure_url;
    } catch (error) {
      console.error('Помилка завантаження зображення:', error);
      return '';
    }
  };

  const uploadImage = async () => {
    if (!fileInput) return;

    setLoading(true);

    try {
      const imageUrl = await handleImageUpload(fileInput);
      if (!imageUrl) {
        throw new Error('Не вдалося отримати URL зображення');
      }

      const serverBaseUrl = process.env.REACT_APP_SERVER_BASE_URL || 'http://localhost:5000';
      await axios.post(`${serverBaseUrl}/api/services-image`, { imageUrl });

      setNotification('Зображення для ServicesPage успішно завантажено!');
      setFileInput(null);
      setTimeout(() => setNotification(null), 3000);
    } catch (error) {
      console.error('Помилка завантаження:', error);
      setNotification('Помилка при завантаженні зображення');
      setTimeout(() => setNotification(null), 3000);
    } finally {
      setLoading(false);
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    uploadImage();
  };

  return (
    <div className="image_uploader">
      <h2>Завантаження зображення для ServicesPage</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="file"
          accept="image/*"
          onChange={handleFileChange}
        />
        <button type="submit" disabled={!fileInput || loading}>
          {loading ? (
            <span className="loading-dots">Завантаження<span>.</span><span>.</span><span>.</span></span>
          ) : (
            'Завантажити'
          )}
        </button>
      </form>
      {notification && <div className="notification">{notification}</div>}
    </div>
  );
};

export default ServicesImageUploader;